import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./avenir-next/46cf1067-688d-4aab-b0f7-bd942af6efd8.ttf%22,%22variable%22:%22--font-avenir-next-regular%22}],%22variableName%22:%22avenirNextRegular%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avenirNextRegular', 'avenirNextRegular Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
